import api from './axiosInstance';

export const getDocumentSendStatus = {
  getStatus: async () => {
    try {
      const response = await api.get(`/DocumentSend/status`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo obtener el listado de estados para las solicitudes de envío. Intenta nuevamente.';
      throw error;
    }
  },
};

export const getDocumentSendPagedRegister = {
  getPagedRegister: async (
    page,
    pageSize,
    search = '',
    statusId,
    sortKey = null,
    sortDirection = null
  ) => {
    try {
      const params = {
        page,
        pageSize,
        search: search || '',
      };

      params.statusId = statusId === null ? null : statusId;

      if (sortKey) params.sortBy = sortKey;
      if (sortDirection !== null) params.desc = sortDirection === 'desc';

      const response = await api.get(`/DocumentSend/paged`, {
        headers: {
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo obtener el listado de documentos en el registro. Intenta nuevamente.';
      throw error;
    }
  },
};

export const getDocumentSendSignedUrl = {
  getSignedUrl: async (id, download = true, expires = 15) => {
    try {
      const response = await api.get(
        `/DocumentSend/document-send/${id}/signed-url`,
        {
          params: { download, expires },
          headers: { 'Content-Type': 'application/json' },
        }
      );

      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo descargar el documento. Intenta nuevamente.';
      throw error;
    }
  },
};
